const ErrorRoutes = {
  ERROR_400: '/error/400',
  ERROR_403: '/error/403',
  ERROR_404: '/error/404',
  ERROR_500: '/error/500',
  ERROR_503: '/error/503',
};

const OtherRoutes = {
  OTHER_BLANK_PAGE: '/other/blank',
  MAINTENANCE_PAGE: '/other/maintenance',
  COMING_SOON: '/other/coming-soon',
  SITE_MAP: '/other/sitemap',
  PRIVACY_POLICY: '/other/privacy-policy',
  TERMS_CONDITION: '/other/terms-condition',
};

const BlankRoutes = {
  ANOTHER_BLANK_PAGE: '/level/blank',
};

const AuthRoutes = {
  OAUTH_SIGN: '/auth/oauth/verify/:id',
};

const FormElementRoutes = {
  FORM_VALIDATION: '/form-elements/form-validation',
  BASE_INPUT: '/form-elements/base-input',
  INPUT_GROUPS: '/form-elements/input-group',
  INPUT_MASKS: '/form-elements/input-mask',
  FLOATING_LABEL: '/form-elements/floating-label',
  DATE_TIME_PICKER: '/form-elements/date-time-picker',
  TOUCH_SPINE: '/form-elements/touch-spine',
  FORM_SELECT: '/form-elements/form-select',
  SWITCH: '/form-elements/switch',
  TYPEAHEAD: '/form-elements/typeahead',
  FORM_TEXTAREA: '/form-elements/form-textarea',
  FORM_CLIPBOARD: '/form-elements/form-clipboard',
  FILE_UPLOAD: '/form-elements/file-upload',
  DEFAULT_FORMS: '/form-elements/default-form',
};

const AssetsRoutes = {
  ASSETS_LIST: '/assets',
  ADD_ASSETS: '/assets/add-assets',
  EDIT_ASSETS: '/assets/:id/edit',
};

const VendorRoutes = {
  VENDOR_LIST: '/vendor',
  ADD_VENDOR: '/vendor/add',
  EDIT_VENDOR: '/vendor/:id/edit',
};

const InventoryRoutes = {
  INVENTORY: '/inventory',
  ADD_INVENTORY: '/inventory/add',
  INVENTORY_LIST: '/inventory',
  EDIT_INVENTORY: '/inventory/:id/edit',
  MANAGE_INVENTORY: '/inventory/:inventoryId/manage',
  STOCK_TRANSFER: '/inventory/:inventoryId/transfer',
  INVENTORY_TRANSFER: '/asset-transfer',
  ADD_INVENTORY_TRANSFER: '/asset-transfer/add',
  VIEW_INVENTORY_TRANSFER: '/asset-transfer/:id/view',
  VIEW_ASSET_SHIPMENT: '/asset-transfer/shipment/:id/view',
  INVENTORY_CASES: '/inventory/cases',
  VIEW_INVENTORY_CASE: '/inventory/cases/:id/view',
};

const GateRegisterRoutes = {
  PERSON_REGISTER: '/gate-register/person',
  VEHICLE_REGISTER: '/gate-register/vehicle',
  PERSON_OPEN_REGISTER: '/gate/person-open/register/:masterWarehouse/:gate',
  PERSON_REGISTER_THANKS: '/gate/person-register/thanks',
};

const DashboardRoutes = {
  DASHBOARD: '/dashboard',
};

const MasterWarehouseRoutes = {
  MASTER_WAREHOUSE_LIST: '/master-warehouse',
  ADD_MASTER_WAREHOUSE: '/master-warehouse/add',
  VIEW_MASTER_WAREHOUSE: '/master-warehouse/:id/view',
  EDIT_MASTER_WAREHOUSE: '/master-warehouse/:id/edit',
};

const GateRoutes = {
  GATE_LIST: '/gate',
  ADD_GATE: '/gate/add',
  VIEW_GATE: '/gate/:id/view',
  EDIT_GATE: '/gate/:id/edit',
};

const UserRoutes = {
  USER_LIST: '/user',
  ADD_USER: '/user/add',
  VIEW_USER: '/user/:id/view',
  EDIT_USER: '/user/:id/edit',
};

const CourierPartnerRoutes = {
  COURIER_PARTNER_LIST: '/courier-partner',
};

const ConsumptionProfileRoutes = {
  CONSUMPTION_PROFILE_LIST: '/consumption-profile',
  CREATE_CONSUMPTION_PROFILE: '/consumption-profile/create',
  EDIT_CONSUMPTION_PROFILE: '/consumption-profile/edit/:id',
  RECORD_CONSUMPTION: '/consumption/record',
  CONSUMPTION_LOGS: '/consumption/logs',
};

const ShiftRoutes = {
  SHIFT_LIST: '/master/shifts',
};

export {
  AuthRoutes,
  BlankRoutes,
  ErrorRoutes,
  OtherRoutes,
  FormElementRoutes,
  AssetsRoutes,
  InventoryRoutes,
  VendorRoutes,
  GateRegisterRoutes,
  DashboardRoutes,
  MasterWarehouseRoutes,
  GateRoutes,
  UserRoutes,
  CourierPartnerRoutes,
  ConsumptionProfileRoutes,
  ShiftRoutes,
};
